import { useTranslation } from "react-i18next";
import ImageWithDescription from "../components/ImageWithDescription";
import TitleHeading from "../components/TitleHeading";
import { replaceStringWithShandeAge } from "../helpers/dataHelper";
import ImageAndDetails2 from "../components/ImageAndDetails2";
import { getOrganizationScope, getOurConsultant } from "../helpers/StaticData/ourOrganizationData";

function OurOrganization() {
    document.title = 'Our Organization | Shan De';
    const {t} = useTranslation();
    const consultantData = getOurConsultant();
    const scopeData = getOrganizationScope();
    return (
        <div className="container">
            <TitleHeading
            title = {t("ourOrganization")}
            className = "pt-4"
            />

            <ImageWithDescription
            img = "assets/img/our_organization/2019.jpg"
            description = {t("ourOrganizationDescription")}
            />

            <ImageWithDescription
            img = "assets/img/our_organization/sammi.jpg"
            title = {t("ourOrganizationSammiTitle")}
            description = {replaceStringWithShandeAge(t("ourOrganizationSammiWords"))}
            imgPortrait = {true}
            reverse = {true}
            />

            <ImageWithDescription
            img = "assets/img/our_organization/simon.jpg"
            title = {t("ourOrganizationSimonTitle")}
            description = {t("ourOrganizationSimonWords")}
            imgPortrait = {true}
            />

            <TitleHeading
            title = {t("ourConsultant")}
            className = "pt-5 text-center"
            />

            <ImageAndDetails2
            data = {consultantData}
            />

            <TitleHeading
            title = {t("ourOrganizationScope")}
            className = "pt-5 text-center"
            />

            {
                scopeData && scopeData.map((item, index) => (
                    <ImageWithDescription
                    key = {item?.title || index}
                    img = {item?.img}
                    title = {item?.title}
                    description = {item?.description}
                    imgCircle = {true}
                    />
                ))
            }
        </div>
    )
}
export default OurOrganization;
